import { CustomShipmentConfigResp } from 'types/api/response/custom-shipment-config-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getCustomShipmentConfig = () =>
  api.get<CustomShipmentConfigResp>('/configurations/custom_shipment', {
    headers: moneyObjectHeader,
  })
